export const Address = () => {
  return (
    <svg
      width="26"
      height="27"
      viewBox="0 0 26 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.4375 0V5.27344H6.32812V3.16406H0V22.1484H2.10938V23.2031C2.10938 24.0601 2.41699 24.7961 3.03223 25.4114C3.66943 26.0486 4.4165 26.3672 5.27344 26.3672C6.13037 26.3672 6.86646 26.0486 7.48169 25.4114C8.1189 24.7961 8.4375 24.0601 8.4375 23.2031V22.1484H25.3125V5.27344H21.0938V0H8.4375ZM10.5469 2.10938H18.9844V7.38281H10.5469V2.10938ZM2.10938 5.27344H4.21875V20.0391H2.10938V5.27344ZM6.32812 7.38281H8.4375V9.49219H21.0938V7.38281H23.2031V20.0391H6.32812V7.38281ZM9.49219 11.6016V13.7109H11.6016V11.6016H9.49219ZM13.7109 11.6016V13.7109H15.8203V11.6016H13.7109ZM17.9297 11.6016V13.7109H20.0391V11.6016H17.9297ZM9.49219 15.8203V17.9297H11.6016V15.8203H9.49219ZM13.7109 15.8203V17.9297H15.8203V15.8203H13.7109ZM17.9297 15.8203V17.9297H20.0391V15.8203H17.9297ZM4.21875 22.1484H6.32812V23.2031C6.32812 23.4888 6.21826 23.7415 5.99854 23.9612C5.80078 24.1589 5.55908 24.2578 5.27344 24.2578C4.98779 24.2578 4.73511 24.1589 4.51538 23.9612C4.31763 23.7415 4.21875 23.4888 4.21875 23.2031V22.1484Z"
        fill="#BB760B"
      />
    </svg>
  );
};
